import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import {
	LayoutDoneServiceSymbol,
	LayoutDiagnosticSymbol,
	RenderDoneObserverSymbol,
	LayoutChangeObserverSymbol,
	RenderDoneHookSymbol,
	LayoutChangeHookSymbol,
} from '@wix/thunderbolt-symbols'
import { ViewerManagerApiImplementor } from 'thunderbolt-viewer-manager-types'
import { ViewerManagerLayoutApi } from './viewerManagerLayoutApi'
import { ComponentWrapperSymbol } from '@wix/thunderbolt-components-loader'
import { ModelUpdatesHandlersImplementor } from 'ds-feature-model-updates-invoker'
import {
	MeasureMapApiSymbol,
	LayoutRegistrarSymbol,
	ScreenSizeApiSymbol,
	ComponentBoundingBoxApiSymbol,
	UpdateLayoutAndPushApiSymbol,
	LayoutUtilsSymbol,
} from './symbols'
import { MeasureMapApi } from './apis/measureMapApi'
import { ScreenSizeApi } from './apis/screenSizeApi'
import { ComponentBoundingBoxApi } from './apis/componentsBoundingBoxApi'
import { RegisterLayoutApi } from './apis/layoutRegistrar'
import { UpdateLayoutAndPushApi } from './apis/updateLayoutAndPushApi'
import { ChangedCompsHandlers } from './sideEffects/changedCompsHandlers'
import { LayoutDoneService } from './services/layoutDoneService'
import { LayoutDiagnostic } from './services/layoutDiagnostic'
import { RenderDoneObserver } from './observers/RenderDoneObserver'
import { LayoutChangeObserver } from './observers/LayoutChangeObserver'
import { LayoutHOC } from './observers/LayoutHOC'
import type { LayoutRegistrar, ICompBoundingBoxApi } from './types'
import { LayoutUtils } from './apis/layoutUtils'

export const editor: ContainerModuleLoader = (bind) => {
	bind(ViewerManagerApiImplementor).to(ViewerManagerLayoutApi)
	bind(ModelUpdatesHandlersImplementor).to(ChangedCompsHandlers)
	bind(MeasureMapApiSymbol, ModelUpdatesHandlersImplementor).to(MeasureMapApi)
	bind(UpdateLayoutAndPushApiSymbol).to(UpdateLayoutAndPushApi)
	bind(ScreenSizeApiSymbol, ModelUpdatesHandlersImplementor).to(ScreenSizeApi)
	bind(ComponentBoundingBoxApiSymbol).to(ComponentBoundingBoxApi)
	bind(LayoutRegistrarSymbol).to(RegisterLayoutApi)
	bind(LayoutDoneServiceSymbol).to(LayoutDoneService)
	bind(RenderDoneObserverSymbol, RenderDoneHookSymbol).to(RenderDoneObserver)
	bind(LayoutChangeObserverSymbol, LayoutChangeHookSymbol).to(LayoutChangeObserver)
	bind(LayoutDiagnosticSymbol).to(LayoutDiagnostic)
	bind(ComponentWrapperSymbol).to(LayoutHOC)
	bind(LayoutUtilsSymbol).to(LayoutUtils)
}

export { MeasureMapApiSymbol }
export type { ICompBoundingBoxApi }
export { LayoutRegistrar, LayoutRegistrarSymbol, ComponentBoundingBoxApiSymbol }
